import React from 'react';
import './OutlinedCard.css';
const OutlinedCard = ({ trackData }) => {
  return (
    <div className="outline-card-block">
      <div className="card-body">
        <h5 className="card-title">Home</h5>
        <p className="card-text">{`${trackData?.houseFlat}, ${trackData?.street}, ${trackData?.landmark}, ${trackData?.city}`}</p>
      </div>
    </div>
  );
};

export default OutlinedCard;